import smartDate from "@qrohlf/smart-date";
import { IntroWidget } from "common/IntroWidget";
import { CalendarDate } from "common/styleguide/CalendarDate";
import { Card } from "common/styleguide/Card";
import { commonMessages, Msg } from "lib/localization";
import { urls } from "lib/urls";
import _ from "lodash";
import React from "react";
import { FormattedMessage as T } from "react-intl";
import { Link } from "react-router-dom";
import { MiniListItem, MiniListItemDetail } from "../DashboardElements";

export class Events extends React.PureComponent {
  render() {
    const { currentUserEvents } = this.props;
    const sorted = _.sortBy(currentUserEvents, ["starts_on", "name"]);
    if (sorted.length > 0) {
      return (
        <Card>
          {sorted.map((e) => (
            <MiniEvent key={e.slug} e={e} />
          ))}
          <Link data-card-link to="/calendar#eventsCard">
            <T id="dashEvents.viewEvents" defaultMessage="View Events" />
          </Link>
        </Card>
      );
    }
    return (
      <Card>
        <IntroWidget
          left={
            <div>
              <CalendarDate date={new Date()} />
            </div>
          }
          link={
            <a href="/find">
              <T id="dashEvents.findEvents" defaultMessage="Find Events" />
            </a>
          }
        >
          <T id="dashEvents.intro" defaultMessage="You have no upcoming events. Find and RSVP to an event." />
        </IntroWidget>
      </Card>
    );
  }
}

const MiniEvent = ({ e }) => (
  <MiniListItem
    href={urls.events.show(e.slug)}
    title={e.name}
    left={
      e.starts_on && <CalendarDate date={e.starts_on} data-tip title={smartDate(e.starts_on, { includeYear: true })} />
    }
  >
    {e.location && <MiniListItemDetail>{e.location}</MiniListItemDetail>}
    <MiniListItemDetail>
      <Msg lowerCase m={commonMessages.byline} values={{ author: e.user_name }} />
    </MiniListItemDetail>
  </MiniListItem>
);
